// const eviltransform = require('eviltransform');
const locations = require('../assets/cleaned-data.json');

module.exports = store;

function store(state, emitter) {
  state.sortKey = 'tri_avg_reported_2014_2019';
  state.showAllListItems = false;
  state.locations = locations
    .map((d) => {
      // const transformed = eviltransform.gcj2wgs(d.lat, d.lon);
      // return Object.assign(d, transformed);

      d[state.sortKey] = parseInt(`${d[state.sortKey]}`.replace(/,/gi, ''), 10);
      // console.log(d);
      // if (d['tri_revision_amount']) {
      //   console.log(d.tri_facility_id, d.owner, d['tri_revision_amount']);
      // }
      // d.expanded = false;
      return d;
    })
    // .filter((d) => d[state.sortKey] >= 500)
    .sort((a, b) => {
      if (a[state.sortKey] > b[state.sortKey]) return -1;
      if (a[state.sortKey] < b[state.sortKey]) return 1;
      return 0;
    });

  // console.log(state.locations.length, 'total locations');
  emitter.on('DOMContentLoaded', function () {
    emitter.on('map:zoom-to-id', (highlightLocation) => {
      if (
        state.highlightLocation &&
        highlightLocation.id == state.highlightLocation.id
      ) {
        state.highlightLocation = null;
        state.selectedFacility = null;
      } else {
        state.highlightLocation = highlightLocation;

        state.selectedFacility = state.locations.filter(
          (l) => l[highlightLocation.key] === highlightLocation.id
        )[0];
      }

      emitter.emit(state.events.RENDER);
    });

    emitter.on('map:closeInfoBox', () => {
      state.highlightLocation = null;
      state.selectedFacility = null;
      emitter.emit(state.events.RENDER);
    });

    emitter.on('map:show-all-toggle', () => {
      state.showAllListItems = !state.showAllListItems;
      emitter.emit(state.events.RENDER);
    });

    setTimeout(() => {
      emitter.emit(state.events.RENDER);
    }, 500);

    if (state.params.facility_id) {
      // console.log(`url facility id: ${state.params.facility_id}`);
      emitter.emit('map:zoom-to-id', {
        key: 'tri_facility_id',
        id: state.params._tri_facility_id
      });
    }
  });
}
